<template>
  <div>
    <PageHeader :items="items" :optionalItems="optionalItems"
      ><template #buttons>
        <div class="d-flex gap-1 flex-wrap referral-page-header" v-if="$can('backoffice-company-logo.upload')">
          <span style="color: #05fffa" class="d-flex align-items-center">{{
            $t("uploadYourLogo")
          }}</span>
          <input
            type="file"
            @change="addFile($event)"
            accept="image/*"
            ref="fileInput"
            style="min-width: 100px"
          />
        </div>
        <div v-if="image.fileSrc">
          <img :src="image.fileSrc" style="width: 90px; height: 40px" />
          <feather-icon
            v-if="$can('backoffice-company-logo.delete')"
            style="color: red"
            @click="deleteLogo()"
            class="ml-1 cursor-pointer"
            size="16"
            icon="TrashIcon"
          />
        </div>
      </template>
    </PageHeader>
    <b-tabs content-class="mt-1">
      <b-tab
        :title="$t('referralLinks')"
        v-if="$can('backoffice-referral-link.list')"
      >
        <ReferralLinks />
      </b-tab>
      <b-tab v-if="$can('backoffice-referral.list')" :title="$t('referral')" lazy>
        <Referral />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import Multiselect from "vue-multiselect";
import Referral from "./components/Referral.vue";
import ReferralLinks from "./components/ReferralLinks.vue";
import fileHandlerMixin from "@/mixins/fileHandlerMixin";

export default {
  components: {
    PageHeader,
    Referral,
    Multiselect,
    ReferralLinks,
  },
  mixins: [fileHandlerMixin],
  computed: {
    optionalItems() {
      return {
        createBtn1: {
          show: false,
          text: this.$t(""),
          icon: "PlusIcon",
          path: "",
          permission: "",
        },
      };
    },
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("referrals"),
          active: true,
        },
      ];
    },
  },
  data() {
    return {
      image: {},
      uploadFile: {},
      companyId: localStorage.getItem("company_id"),
    };
  },

  async created() {
    this.loadCompanyLogo();
  },

  methods: {
    async addFile(event) {
      const file = event.target.files[0];
      const response2 = await this.handleFileUpload(file);
      if (!response2?.data[0]?.id) {
        this.$store.commit("showLoader", false);
      } else {
        this.uploadFile = {
          id: response2?.data[0]?.id,
          name: response2?.data[0]?.originalFileName,
          extension: response2?.data[0]?.type,
        };
      }
      await this.$store
        .dispatch("customers/uploadLogo", {
          image: this.uploadFile,
        })
        .then(async (res) => {
          await this.loadCompanyLogo();
        });
    },
    async deleteLogo() {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToDeleteTheLogo"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        try {
          this.$store.commit("showLoader", true);
          await this.$store.dispatch("customers/deleteLogo");
          this.image = {};
        } catch (e) {
          console.error("api error ___", e);
        } finally {
          this.$store.commit("showLoader", false);
        }
      }
    },
    async loadCompanyLogo() {
      await this.$store
        .dispatch("customers/show", this.companyId)
        .then((res) => {
          let data = res?.data?.modelData;
          if (data.image) {
            this.getImage(data.image.id, "fileSrc", this.image);
          }
        });
    },
  },
};
</script>
